import {
  Component,
  Input,
  OnInit
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

import {
  DayOfWeek,
  DayOfWeekMapping,
  DisplaySchema,
  SummitIdObject
} from '@summit/models';
import { ApiError } from '@summit/ui';
import { SFormInputEnumComponent } from '../s-form-input-enum';

@Component({
  selector: 's-form-input-select-day-of-week',
  templateUrl: './form-input-select-day-of-week.component.html',
  styleUrls: ['./form-input-select-day-of-week.component.scss'],
  standalone: true,
  imports: [SFormInputEnumComponent]
})
export class FormInputSelectDayOfWeekComponent<T extends SummitIdObject> implements OnInit {
  @Input() label: string;
  @Input() groupName: string;
  @Input() fieldName: keyof T & string;
  @Input() form: UntypedFormGroup;
  @Input() defaultText: string;
  @Input() apiError: ApiError;
  @Input() schema: DisplaySchema<T>;
  @Input() filter: number[];
  @Input() displayHint?: string;

  // ENUMS
  dayOfWeek = Object.keys(DayOfWeek)
    .map((x) => Number(x))
    .filter((x) => !Number.isNaN(x));
  dayOfWeekMapping = DayOfWeekMapping;

  ngOnInit() {
    if (!this.label) {
      if (this.schema) {
        this.label = this.schema.getDisplayName(this.fieldName) ?? this.fieldName;
      }
    }
  }
}
